import React, { useMemo } from 'react';
import classname from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import Ellipsis from '@wix/da-ds/pkg/Icons/Ellipsis';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Check from '@wix/da-ds/pkg/Icons/16x16/Check';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import UserAvatar from '../../../../User/Avatar/UserAvatarWithPopover';
import UserLink from '../../../../User/Link/UserLinkWithTooltip';
import { getDeviationResourceType, getDeviationTitle } from '../../../_helpers';
import ThumbActions from '../../../Helper/ThumbActions';
import { useWatchButton } from '../../../../WatchButton/useWatchButton';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import FaveControl from '../FaveControl';
import CommentControl from '../CommentControl';
import s from './ThumbOverlayHover.scss';
const ThumbOverlayHover = ({ deviation, width, height, children, className, extraActions, onRemove })=>{
    const { showTitle, showAuthor, showCommentControl, showAuthorTooltip, showFaveControl, showExtraActions, showAuthorName, showAuthorWatchButton } = useOverlayContext(deviation);
    const { isWatching, text } = useWatchButton(deviation.author);
    const blockType = useDeviationBlockType(deviation);
    const showSmallerActions = !!height && height < 150;
    const canShowTitle = useMemo(()=>{
        if (!showTitle) {
            return false;
        }
        switch(blockType){
            case 'subsOnly':
            case 'subBlocked':
                return height && height > 250;
            case 'premiumFolder':
                return height && height > 210;
            case 'watchersOnly':
                return height && height > 180;
            default:
                return true;
        }
    }, [
        blockType,
        height,
        showTitle
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK,
        className: classname(s['root'], className),
        style: {
            width,
            height
        },
        tag: "div"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['top']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }), /*#__PURE__*/ React.createElement(HoverOnly, {
        className: s['right']
    }, showExtraActions && extraActions && /*#__PURE__*/ React.createElement(ThumbActions, {
        className: s['actions'],
        deviation: deviation,
        actions: extraActions
    }, /*#__PURE__*/ React.createElement(IconButtonWithBackground, {
        size: showSmallerActions ? 'small' : 'medium',
        icon: Ellipsis
    })), onRemove && /*#__PURE__*/ React.createElement(IconButtonWithBackground, {
        className: s['remove-button'],
        size: "medium",
        icon: CloseIcon,
        onClick: onRemove,
        biData: BiData({
            evid: 405,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            rank: BiContextProvidedValue
        })
    }))), /*#__PURE__*/ React.createElement(HoverOnly, {
        className: s['middle']
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom']
    }, /*#__PURE__*/ React.createElement(HoverOnly, {
        className: s['left']
    }, canShowTitle && /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        className: s['title']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['title-heading']
    }, getDeviationTitle(deviation))), showAuthor && deviation.author && /*#__PURE__*/ React.createElement("div", {
        className: s['author']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['avatar-and-username']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: deviation.author,
        size: 24,
        withLink: true,
        withTooltip: showAuthorTooltip,
        className: s['avatar']
    }), showAuthorName && /*#__PURE__*/ React.createElement(UserLink, {
        user: deviation.author,
        withTooltip: showAuthorTooltip,
        className: s['userlink']
    })), isWatching && showAuthorWatchButton && /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "main",
        disabled: true,
        icon: Check
    }, text))), /*#__PURE__*/ React.createElement(HoverOnly, {
        className: classname(s['right'], s['stats'])
    }, showCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        deviation: deviation,
        showStatNumbers: true,
        className: s['stat']
    }), showFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        deviation: deviation,
        showStatNumbers: true,
        className: s['stat']
    }))));
};
ThumbOverlayHover.displayName = 'ThumbOverlayHover';
export default ThumbOverlayHover;
